// src/helpers/register/orderCreation/customizer.ts
var isCustomizerSuperSet = (A, B) => {
  const keysA = new Set(
    Object.entries(A).filter(([, value]) => value).map(([key]) => key)
  );
  const keysB = Object.entries(B).filter(([, value]) => value).map(([key]) => key);
  return keysB.every((key) => keysA.has(key));
};
var isCustomizerSubSet = (A, B) => {
  return isCustomizerSuperSet(B, A);
};
var hasCustomizerCollision = (A, B) => {
  const keysA = new Set(
    Object.entries(A).filter(([, value]) => value).map(([key]) => key)
  );
  const keysB = Object.entries(B).filter(([, value]) => value).map(([key]) => key);
  return keysB.some((key) => keysA.has(key));
};
var isCustomizerWholeSelected = (customizer) => {
  return customizer.topLeft && customizer.bottomLeft && customizer.topRight && customizer.bottomRight;
};
var isCustomizerLeftHalfSelected = (customizer) => {
  return customizer.topLeft && customizer.bottomLeft;
};
var isCustomizerRightHalfSelected = (customizer) => {
  return customizer.topRight && customizer.bottomRight;
};
var getSingleSections = (customizer) => {
  const sections = [];
  if (customizer.topLeft && !customizer.bottomLeft) {
    sections.push("topLeft");
  }
  if (!customizer.topLeft && customizer.bottomLeft) {
    sections.push("bottomLeft");
  }
  if (customizer.topRight && !customizer.bottomRight) {
    sections.push("topRight");
  }
  if (!customizer.topRight && customizer.bottomRight) {
    sections.push("bottomRight");
  }
  return sections;
};

export { getSingleSections, hasCustomizerCollision, isCustomizerLeftHalfSelected, isCustomizerRightHalfSelected, isCustomizerSubSet, isCustomizerSuperSet, isCustomizerWholeSelected };
